export const JOURNEY_OPTIONS = [
  { key: 'questioning' },
  { key: 'seeking' },
  { key: 'changing' },
  { key: 'belonging' },
  { key: 'advocacy' },
]

// Archetype labels and descriptions are translated via the static-text
// pipeline. Each archetype's display copy lives under `archetype_<key>` and
// `archetype_<key>Desc` in the per-page lang JSON (CommunityProfilePage uses
// labels only; CommunityProfileSettingsPage uses both). See InterestsCard
// and ProfileArchetypesSection for the hook-based lookup.
export const ARCHETYPES = [
  { key: 'seeker' },
  { key: 'rebel' },
  { key: 'healer' },
  { key: 'mystic' },
  { key: 'explorer' },
  { key: 'observer' },
  { key: 'alchemist' },
  { key: 'guardian' },
  { key: 'visionary' },
]

export const MAX_ARCHETYPES = 3

// Vibe-line quiz options. Strings are sent verbatim to the
// `oracleIdentityVibeGenerate` mutation as the AI's quiz-answer context, so
// edits here change generator output. Vocabulary mirrors Figma node 3663-104331.
export const ENERGY_OPTIONS = [
  'Integrated', 'Inspired', 'Intuitive', 'Expressive',
  'Open', 'Confident', 'Creative', 'Grounded',
]

export const FEELS_TRUE_OPTIONS = [
  "I'm integrating something big",
  "I'm in a season of clarity",
  "I'm simplifying my life",
  "I'm reconnecting with myself",
  "I'm asking deeper questions",
  "I'm navigating change",
]

export const SHAPING_DAYS_OPTIONS = [
  'Rest & recovery', 'Breathwork',
  'Study & learning', 'Community',
  'Service', 'Letting go',
  'Creative work', 'Movement & yoga',
]

export const MAX_ENERGY_PICKS = 2
export const MAX_FEELS_PICKS = 2
export const MAX_SHAPING_PICKS = 2
